export const BG_COLOUR_MAP = {
  light: 'bg-light',
  primary: 'bg-primary',
  secondary: 'bg-secondary',
  dark: 'bg-dark',
};

export const TEXT_COLOUR_MAP = {
  light: 'text-dark',
  primary: 'text-light',
  secondary: 'text-dark',
  dark: 'text-light',
};

export const PROSE_COLOUR_MAP = {
  light: '',
  primary: 'prose-dark',
  secondary: '',
  dark: 'prose-dark',
};
